(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-review-slider"] && !Shopify.designMode) return;
  try {
    
  class CustomReviewSlider extends HTMLElement {
    connectedCallback() {
      this.cardsPerView = parseInt(this.dataset.cardsPerView, 10) || 3;

      this.cardsPerViewTablet = parseInt(this.dataset.cardsPerViewTablet, 10) || 2;

      this.maxMobileDots = parseInt(this.dataset.maxMobileDots, 10) || 5;

      this.showDots = this.dataset.showDots === 'true';

      this.currentIndex = 0;

      this.track = this.querySelector('.custom-review-slider__track');

      this.cards = Array.from(this.querySelectorAll('.custom-review-slider__card'));

      this.prevButtons = this.querySelectorAll('.custom-review-slider__button--prev');

      this.nextButtons = this.querySelectorAll('.custom-review-slider__button--next');

      this.dotsContainer = this.querySelector('.custom-review-slider__dots');

      this.controlsContainer = this.querySelector('.custom-review-slider__controls');

      if (!this.track || !this.cards.length) {
        return;
      }

      this.updateCardsPerView();

      this.createDots();

      this.updateControls();

      this.updateSlider();

      this.setupEventListeners();

      this._onResize = () => {
        const previousCardsPerView = this.currentCardsPerView;

        this.updateCardsPerView();

        if (previousCardsPerView !== this.currentCardsPerView) {
          this.currentIndex = Math.min(this.currentIndex, this.totalSlides - 1);

          this.createDots();
        }

        this.updateControls();

        this.updateSlider();
      };

      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize);
      }
    }

    updateCardsPerView() {
      const width = window.innerWidth;

      if (width <= 749) {
        this.currentCardsPerView = 1;
      } else if (width <= 989) {
        this.currentCardsPerView = this.cardsPerViewTablet;
      } else {
        this.currentCardsPerView = this.cardsPerView;
      }

      /*
      IMPORTANT:
      Keep CSS and JavaScript in sync.
    */

      this.style.setProperty('--current-cards-per-view', this.currentCardsPerView);

      this.totalSlides = Math.max(1, Math.ceil(this.cards.length / this.currentCardsPerView));
    }

    createDots() {
      if (!this.dotsContainer || !this.showDots) {
        return;
      }

      this.dotsContainer.innerHTML = '';

      if (this.totalSlides <= 1) {
        return;
      }

      for (let index = 0; index < this.totalSlides; index++) {
        const dot = document.createElement('button');

        dot.type = 'button';

        dot.className = 'custom-review-slider__dot';

        dot.setAttribute('aria-label', `Go to review slide ${index + 1}`);

        dot.addEventListener('click', () => this.goToSlide(index));

        this.dotsContainer.appendChild(dot);
      }
    }

    setupEventListeners() {
      this.prevButtons.forEach((button) => {
        button.addEventListener('click', () => this.prev());
      });

      this.nextButtons.forEach((button) => {
        button.addEventListener('click', () => this.next());
      });
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;

        this.updateSlider();
      }
    }

    next() {
      if (this.currentIndex < this.totalSlides - 1) {
        this.currentIndex++;

        this.updateSlider();
      }
    }

    goToSlide(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.totalSlides - 1));

      this.updateSlider();
    }

    updateControls() {
      const hasMultipleSlides = this.totalSlides > 1;

      if (this.controlsContainer) {
        this.controlsContainer.style.display = hasMultipleSlides ? '' : 'none';
      }

      [...this.prevButtons, ...this.nextButtons].forEach((button) => {
        if (button.classList.contains('custom-review-slider__button--inside')) {
          button.style.display = hasMultipleSlides ? 'flex' : 'none';
        }
      });
    }

    updateDotsVisibility() {
      if (!this.dotsContainer) {
        return;
      }

      const dots = this.dotsContainer.querySelectorAll('.custom-review-slider__dot');

      const isMobile = window.innerWidth <= 749;

      if (!isMobile) {
        dots.forEach((dot) => {
          dot.classList.remove('hide-mobile');
        });

        return;
      }

      const maxDots = this.maxMobileDots;

      const totalDots = dots.length;

      let start = Math.max(0, this.currentIndex - Math.floor(maxDots / 2));

      let end = Math.min(totalDots, start + maxDots);

      if (end - start < maxDots) {
        start = Math.max(0, end - maxDots);
      }

      dots.forEach((dot, index) => {
        dot.classList.toggle('hide-mobile', index < start || index >= end);
      });
    }

    updateSlider() {
      if (!this.track || !this.cards.length) {
        return;
      }

      /*
      offsetWidth gives us the actual rendered
      card width after the cards-per-view CSS
      calculation has been applied.
    */

      const cardWidth = this.cards[0].offsetWidth;

      const gap = parseFloat(getComputedStyle(this).getPropertyValue('--card-gap')) || 0;

      const offset = this.currentIndex * this.currentCardsPerView * (cardWidth + gap);

      this.track.style.transform = `translate3d(-${offset}px, 0, 0)`;

      this.prevButtons.forEach((button) => {
        button.disabled = this.currentIndex === 0;
      });

      this.nextButtons.forEach((button) => {
        button.disabled = this.currentIndex >= this.totalSlides - 1;
      });

      if (this.showDots && this.dotsContainer) {
        const dots = this.dotsContainer.querySelectorAll('.custom-review-slider__dot');

        dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === this.currentIndex);
        });

        this.updateDotsVisibility();
      }
    }
  }

  if (!customElements.get('custom-review-slider')) {
    customElements.define('custom-review-slider', CustomReviewSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
